// extracted by mini-css-extract-plugin
export default {"label":"PassportReviewItem_label__PH32k","unset":"PassportReviewItem_unset__sL722"};